import get from 'lodash/get';
import merge from 'lodash/merge';
import toArray from 'lodash/toArray';

import moulages from '../../config/moulages';
import makeMoulageLabel from '../../utils/makeMoulageLabel';
import isInvalidMoulage from '../../config/invalidMoulageCombos';
import { caseLogicMsg } from '../validationMessages';

function validateMoulageNodes(caseConf) {
  const errors = [];

  const caseMoulages = merge({}, caseConf.moulages, caseConf.structuralMoulages);
  const nodes = get(caseConf, 'caseLogicDescription.nodes', []);
  const effectNodes = toArray(nodes).filter(node => node.name === 'Effect');
  const behaviorChangeNodes = effectNodes.filter(
    (node) => {
      const effectType = get(node, 'data.effect.type');
      return  effectType === 'ANIMATION_REPEAT' || effectType === 'ANIMATION_ONE_SHOT'
    }
  );

  // Stance
  for (const [location, moulageKey] of Object.entries(caseMoulages)) {
    const moulage = moulages.find(m => m.key === moulageKey);
    if (!moulage) {
      continue;
    }

    if (moulage.stanceRestrictions) {
      // Case Logic
      for (const node of behaviorChangeNodes) {
        const position = get(node, 'data.effect.position');
        if (isStanceRestricted(moulage, location, position)) {
          errors.push(
            caseLogicMsg(`${makeMoulageLabel(moulage.key)} is not compatible with position change`, node.id)
          );
        }
      }
    }
  }

  // Edema changes in case logic
  const edemaChangeNodes = toArray(nodes).filter(
    (node) => get(node, 'data.effect.type') === 'STRUCTURAL_MOULAGE'
  );
  for (const node of edemaChangeNodes) {
    const id = get(node, 'data.effect.id');
    if (id === 'LEFT_LEG' || id === 'RIGHT_LEG') {
      const location = id === 'LEFT_LEG' ? 'LEFT_LEG_UPPER' : 'RIGHT_LEG_UPPER';
      const moulageKey = get(node, 'data.effect.value');
      const message = isInvalidMoulage(location, moulageKey, caseMoulages);
      if (message) {
        errors.push(
          caseLogicMsg(message, node.id)
        );
      }
    }
  }

  return {
    errors,
    warnings: [],
  };
}

function isStanceRestricted(moulage, location, position) {
  return get(moulage.stanceRestrictions, location, []).includes(position) ||
         get(moulage.stanceRestrictions, 'ANY', []).includes(position);
}

export default validateMoulageNodes;